import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';

import AttributeList from './AttributeListWidget';
import AttributeEdit from './AttributeEditWidget';

class AttributeManagement extends React.Component {

    constructor(props, context) {
        super(props, context);

        let attribute1 = {
            name: 'Attribute 1',
            required: false,
            type: 'Text',
            values: []
        };

        let attribute2 = {
            name: 'Attribute 2',
            required: true,
            type: 'Combo',
            values: ['Apples', 'Bananas', 'Pears']
        };

        let attributes = [attribute1, attribute2];

        this.state = {
            attributes: attributes,
            activeAttribute: null,
            showNew: false
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleEditCancel = () => {
        this.setState({
            showNew: false,
            activeAttribute: null
        });
    }

    handleEditSave = () => {

    }

    handleNew = () => {
        this.setState({
            showNew: !this.state.showNew
        });
    }

    handleNewSave = () => {

    }

    handleSelect (attribute) {
        if (!this.state.showNew)
            this.setState({
                activeAttribute: attribute
            });
    }

    // RENDER METHOD

    render = () => {
        let editHeader = this.state.activeAttribute === null || this.state.showNew ?
                            <h3 className="text-center"> New attribute </h3>
                            :
                            <h3 className="text-center"> {this.state.activeAttribute.name} </h3>;

        return (
            <Row>
                <Col md={3} mdOffset={1}>
                    <AttributeList
                        attributes={this.state.attributes}
                        handleSelectAttribute={this.handleSelect}
                        handleNewAttribute={this.handleNew}
                        />
                </Col>
                <Col md={7}>
                    {
                        this.state.showNew ?
                            <AttributeEdit
                                header={editHeader}
                                handleSave={this.handleNewSave}
                                handleCancel={this.handleNew}
                                />
                        :

                            this.state.activeAttribute == null ?
                            null
                            :
                            <AttributeEdit
                                header={editHeader}
                                edit
                                attribute={this.state.activeAttribute}
                                handleSave={this.handleEditSave}
                                handleCancel={this.handleEditCancel}
                                />
                    }
                </Col>
            </Row>
        );
    }
}

export default connect()(AttributeManagement);


/** WEBPACK FOOTER **
 ** ./src/app/components/AttributeManagement.js
 **/